<template>
  <section class="MyOrdersDetails" id="order-details-page">
    <div class="page-banner orders-banner">
      <el-row>
        <el-col :lg="24">
          <div class="image">
            <img
              src="/img/page-banners/orders.jpg"
              alt="storeLocator-page-banner"
              class="img-fluid"
            />
            <div class="banner-cover">
              <div class="banner-cover-inner">
                <ul class="bredcums-list">
                  <li>
                    <router-link to="/">Home</router-link>
                  </li>

                  <li>
                    <router-link to="/">Orders</router-link>
                  </li>
                </ul>
                <h3 class="bredcums-title">Order Details</h3>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <App-StoreFilter />
    </div>
    <section class="orders-block section-pad">
      <el-row type="flex" justify="center">
        <el-col :lg="20">
          <div class="each-order">
            <el-row :gutter="10">
              <el-col :lg="6">
                <h4 class="order-title">Invoice</h4>
                <p class="order-data">#01245678</p>
              </el-col>
              <el-col :lg="6">
                <h4 class="order-title">Payment Status</h4>
                <p class="order-data green">SUCCESS</p>
              </el-col>
              <el-col :lg="6">
                <h4 class="order-title">Order Status</h4>
                <p class="order-data orange">PENDING</p>
              </el-col>
              <el-col :lg="6">
                <h4 class="order-title">Order Date</h4>
                <p class="order-data">21/08/2019</p>
              </el-col>
            </el-row>
            <el-row :gutter="30" class="each-order-address-block">
              <el-col :lg="8">
                <h4 class="order-title">Billing address</h4>
                <div class="order-data">
                  <address>
                    <p>Flat #502, Sri Ganesh Towers,</p>
                    <p>Near Penamaluru Rice Mill,</p>
                    <p>Penamaluru, Vijayawada,</p>
                    <p>Andhra Pradesh - 521139</p>
                  </address>
                </div>
              </el-col>
              <el-col :lg="8">
                <h4 class="order-title">Shipping address</h4>
                <div class="order-data">
                  <address>
                    <p>Flat #502, Sri Ganesh Towers,</p>
                    <p>Near Penamaluru Rice Mill,</p>
                    <p>Penamaluru, Vijayawada,</p>
                    <p>Andhra Pradesh - 521139</p>
                  </address>
                </div>
              </el-col>
              <el-col :lg="8">
                <h4 class="order-title">Total Amount</h4>
                <p class="order-data blod">$ 952.42</p>
              </el-col>
            </el-row>
          </div>
          <div class="order-details-table">
            <el-table :data="orderDetails" height="550" style="width: 100%">
              <el-table-column prop="id" width="80"></el-table-column>
              <el-table-column label="Product">
                <template slot-scope="scope">
                  <div class="product-group">
                    <div class="product-image">
                      <img
                        :src="'/img/accessories/'+ scope.row.product.image "
                        :alt="scope.row.product.name"
                        class="img-fluid"
                      />
                    </div>
                    <div class="product-details">
                      <h3>{{scope.row.product.name}}</h3>
                      <p>{{scope.row.product.description}}</p>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="Price" width="180"></el-table-column>
              <el-table-column prop="quantity" label="Quantity" width="180"></el-table-column>
              <el-table-column prop="total" label="Total" width="180"></el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </section>
  </section>
</template>

<script>
import AdminDefault from "@/layouts/AdminDefault";

export default {
  name: "MyOrdesDetails",
  data() {
    return {
      orderDetails: [
        {
          id: 1,
          product: {
            image: "accessories-5.png",
            name: "JBL T450BT",
            description:
              "JBL has engineered the precise, impressive sound found in big venues around the world."
          },
          price: "$ 37.72",
          quantity: 1,
          total: "$ 37.72"
        },
        {
          id: 2,
          product: {
            image: "accessories-6.png",
            name: "JBL T450BT",
            description:
              "JBL has engineered the precise, impressive sound found in big venues around the world."
          },
          price: "$ 37.72",
          quantity: 1,
          total: "$ 37.72"
        },
        {
          id: 2,
          product: {
            image: "accessories-6.png",
            name: "JBL T450BT",
            description:
              "JBL has engineered the precise, impressive sound found in big venues around the world."
          },
          price: "$ 37.72",
          quantity: 1,
          total: "$ 37.72"
        },
        {
          id: 2,
          product: {
            image: "accessories-6.png",
            name: "JBL T450BT",
            description:
              "JBL has engineered the precise, impressive sound found in big venues around the world."
          },
          price: "$ 37.72",
          quantity: 1,
          total: "$ 37.72"
        }
      ]
    };
  },
  created() {
    this.$emit("update:layout", AdminDefault);
    this.$root.$emit('closenav', false);

  }
};
</script>



<style lang="scss">
#order-details-page {
  .orders-block {
    .each-order {
      background: #fbfbfb;
      padding: 30px 20px;
      margin-bottom: 40px;
      .order-title {
        font-size: 14px;
        line-height: 13px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        color: #4d4d4d;
        margin-bottom: 15px;
      }
      .green {
        color: #12ab0f !important;
      }
      .blod {
        font-weight: 600;
      }
      .orange {
        color: #eeae31 !important;
      }
      .order-data {
        color: #7b7b7b;
        font-size: 13px;
      }
      .each-order-address-block {
        margin-top: 50px;
        address {
          font-style: normal;
          p {
            margin: 0;
          }
        }
      }
    }
  }
}
</style>
